import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	projects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectsGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	projects: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.projects.projects',
		defaultMessage: 'Projects',
		description: 'Section title for projects',
	},
	projectsGalaxia: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.projects.projects-galaxia',
		defaultMessage: 'Spaces',
		description: 'Section title for projects',
	},
});
